import {
  accountsListData,
  verticalBarChartData,
  topVisitedPages,
  salesPersonaEngagementData,
  campaignsPerformanceTableData,
  campaignPerformanceTrendChartData,
  mockedLeastEngagingAccounts,
} from './mockedData';

export const viewConfig = {
  HighlyLikelyNoCampaignsView: [
    {
      component: 'AccountsCampaignsTrendChart',
      data: verticalBarChartData,
      key: 'accountsCampaignTrendChart',
    },
    {
      component: 'HighlyLikelyAccountsTable',
      data: accountsListData,
      key: 'highlyLikelyAccountsTable',
    },
    // Hiding TopEngagedPagesKeywordsCharts - not relevant for Demo
    // {
    //   component: 'TopEngagedPagesKeywordsCharts',
    //   data: engagedPagesAndKeywordsData,
    //   key: 'engagementChart',
    // },
  ],
  SalesPersonaGapView: [
    {
      component: 'SalesPersonaEngagementChart',
      data: salesPersonaEngagementData,
      key: 'salesPersonaChart',
    },
    // Hiding ContactLists - not relevant for Demo.
    // { component: 'ContactLists', data: contactLists, key: 'contactLists', shouldWrapInCard: false },
    {
      component: 'Bottom10EngagingAccounts',
      data: mockedLeastEngagingAccounts,
      key: 'bottom10EngagingAccounts',
    },
    { component: 'TopVisitedWebPages', data: topVisitedPages, key: 'topVisitedPages' },
  ],
  CampaignPerformanceAnalytics: [
    {
      component: 'CampaignPerformanceTrendChart',
      data: campaignPerformanceTrendChartData,
      key: 'campaignPerformanceTrendChart',
    },
    {
      component: 'CampaignPerformanceTables',
      data: campaignsPerformanceTableData,
      key: 'campaignTables',
      shouldWrapInCard: false,
    },
  ],
};
